// extracted by mini-css-extract-plugin
module.exports = {"bulletList":"SharedDetails_bulletList__JEhB0","anchor":"SharedDetails_anchor__yuRdJ"};